// $(document).ready(function () {
//   $('#myCarousel').carousel({
//       interval: 2000
//   })
//   $('.carousel .carousel-item').each(function () {
//       var next = $(this).next();
//       if (!next.length) {
//           next = $(this).siblings(':first');
//       }
//       next.children(':first-child').clone().appendTo($(this));
//       if (next.next().length > 0) {
//           next.next().children(':first-child').clone().appendTo($(this));
//       } else {
//           $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
//       }
//   });
// });


// WEBPACK FOOTER //
// ./js/inc/carousel.js